/* eslint-disable react/jsx-key */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useEffect, useMemo, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useSnackbar } from 'notistack';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { makeStyles } from '@mui/styles';
import { useNavigate, useParams } from 'react-router';
import { Grid, Box, Typography, Button, Modal, FormControl } from '@mui/material';
import axiosInstance from '../../../utils/axios';
import { FormProvider, RHFSelect, RHFTextField } from '../../../components/hook-form';

const useStyles = makeStyles((theme) => ({
  container: {
    padding: theme.spacing(2),
  },
  walletBox: {
    padding: theme.spacing(2),
    backgroundColor: 'white',
    borderRadius: theme.shape.borderRadius,
    marginBottom: theme.spacing(2),
  },
  blockBigText: {
    fontSize: '2rem',
    marginBottom: theme.spacing(1),
  },
  walletLabel: {
    fontSize: '0.875rem',
    color: theme.palette.text.secondary,
  },
  btnSlim: {
    marginTop: theme.spacing(2),
  },
  modalContent: {
    padding: theme.spacing(2),
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    borderRadius: theme.shape.borderRadius,
    width: '400px',
  },
  formGroup: {
    marginBottom: theme.spacing(2),
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
    '& th, & td': {
      border: '1px solid #ccc',
      padding: theme.spacing(1),
    },
    '& th': {
      backgroundColor: theme.palette.grey[200],
    },
  },
  labelSuccess: {
    color: '#fff',
    backgroundColor: theme.palette.success.main,
    padding: theme.spacing(0.5, 1),
    borderRadius: theme.shape.borderRadius,
  },
}));

const PayoutsSearch = () => {
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const { id } = useParams();
  const [getSignlePayout, setGetSignlePayout] = useState([]);
  const [getSignleWallet, setGetSignleWallet] = useState([]);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const NewCompanySchema = Yup.object().shape({
    adj_title: Yup.string().required('Required Title'),
    adj_amount: Yup.string().required('Required Amount'),
    adj_action: Yup.string().required('Required Action'),
    adj_reason: Yup.string().required('Required Reason'),
  });

  const defaultValues = useMemo(
    () => ({
      adj_title: '',
      adj_amount: '',
      adj_action: '',
      adj_reason: '',
    }),
    []
  );

  const methods = useForm({
    resolver: yupResolver(NewCompanySchema),
    defaultValues,
  });
  const {
    reset,
    // eslint-disable-next-line no-unused-vars
    setValue,
    handleSubmit,
    formState: { isSubmitting, errors },
  } = methods;

  const OnSubmit = async (data) => {
    try {
      const formData = new FormData();
      formData.append('user_id', id);
      formData.append('title', data?.adj_title);
      formData.append('amount', data?.adj_amount);
      formData.append('type', data?.adj_action);
      formData.append('reason', data?.adj_reason);
      await axiosInstance.post('payout', formData).then((response) => {
        console.log(response?.data);
        if (response?.data?.status === true) {
          enqueueSnackbar('Add Amount Successfully');
          reset();
          SinglePayout();
        }
      });
    } catch (error) {
      enqueueSnackbar(error?.message, {
        variant: 'error',
      });
      console.error(error);
    }
  };

  async function SingleWallet() {
    const data = await axiosInstance.get(`wallet?user_id=${id}`);
    setGetSignleWallet(data?.data);
  }

  async function SinglePayout() {
    const data = await axiosInstance.get(`payout?user_id=${id}`);
    setGetSignlePayout(data?.data?.data);
  }

  useEffect(() => {
    SinglePayout();
    SingleWallet();
  }, []);

  return (
    <Box className={classes.container}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Box>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={4}>
                <Box className={classes.walletBox}>
                  <Typography className={classes.blockBigText}>$ {getSignleWallet?.total_earning}</Typography>
                  <Typography variant="h5">
                    Total Earnings <span className={classes.walletLabel}>Host Fee: 3%</span>
                  </Typography>
                  <Typography variant="body2">
                    Excluding the service fee, the host fee and the security deposit
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={12} sm={4}>
                <Box className={classes.walletBox}>
                  <Typography className={classes.blockBigText}>$ {getSignleWallet?.available}</Typography>
                  <Typography variant="h5">Available Balance</Typography>
                  <Typography variant="body2">
                    Represents the available amount you can currently withdraw to your account.
                  </Typography>
                  <Button variant="contained" color="primary" className={classes.btnSlim} onClick={handleOpen}>
                    Add Adjustment
                  </Button>
                  <Modal
                    open={open}
                    onClose={handleClose}
                    sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
                  >
                    <Box className={classes.modalContent}>
                      <Typography className='mt-2' variant="h6">Make Adjustment</Typography>
                      <FormProvider methods={methods} onSubmit={handleSubmit(OnSubmit)}>
                        <div className={classes.formGroup}>
                          <RHFTextField fullWidth name="adj_title" label="Title" />
                        </div>
                        <div className={classes.formGroup}>
                          <RHFTextField fullWidth name="adj_amount" label="Amount (only number)" />
                        </div>
                        <div className={classes.formGroup}>
                          <FormControl fullWidth>
                            <RHFSelect name="adj_action" label="Duration Period" placeholder="Action">
                              <option value="deduct">Deduct </option>
                              <option value="add">Add</option>
                            </RHFSelect>
                          </FormControl>
                        </div>
                        <div className={classes.formGroup}>
                          <RHFTextField fullWidth name="adj_reason" label="Reason" multiline rows={5} />
                        </div>
                        <Button type="submit" variant="contained" size="large" loading={isSubmitting}>
                          Submit
                        </Button>
                      </FormProvider>
                    </Box>
                  </Modal>
                </Box>
              </Grid>
              <Grid item xs={12} sm={4}>
                <Box className={classes.walletBox}>
                  <Typography className={classes.blockBigText}>$ {getSignleWallet?.total_booking}</Typography>
                  <Typography variant="h5">Total Reservations</Typography>
                  <Typography variant="body2">
                    Represents the total number of paid reservations you have received
                  </Typography>
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Box className={classes.walletBox}>
            <Typography variant="h6">Earnings</Typography>
            <Typography variant="body2">At the moment there are no earnings.</Typography>
          </Box>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Box className={classes.walletBox}>
            <Typography variant="h6">Payouts</Typography>
            <table className={classes.table}>
              <thead>
                <tr>
                  <th>Date Requested</th>
                  <th>Amount</th>
                  <th>Status</th>
                  <th>Date Processed</th>
                </tr>
              </thead>
              <tbody>
                {getSignlePayout?.map((payout) => (
                  <tr>
                    <td>{payout?.date}</td>
                    <td>+ $ {payout?.amount}</td>
                    <td>
                      <span className={classes.labelSuccess}>{payout?.status}</span>
                    </td>
                    <td>{payout?.date}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default PayoutsSearch;
